import { useLayoutEffect, useRef } from 'react'

const MIN_ZOOM = 0.5

/**
 * Экран квиза без прокрутки: если содержимое выше экрана, маскот уменьшается на недостающее, но
 * не меньше чем вдвое. Не хватило и этого — остаётся прокрутка: иначе текст был бы недоступен.
 */
export const useFitMascot = (enabled: boolean) => {
  const scrollerRef = useRef<HTMLDivElement>(null)
  const mascotRef = useRef<HTMLDivElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const scroller = scrollerRef.current
    const mascot = mascotRef.current
    const content = contentRef.current
    if (!enabled || !scroller || !mascot || !content) return
    const fit = () => {
      mascot.style.zoom = ''
      const height = mascot.offsetHeight
      if (height <= 0) return
      // Меряем заново после каждого шага: картинка маскота масштабируется не строго линейно.
      let zoom = 1
      for (let step = 0; step < 4 && zoom > MIN_ZOOM; step += 1) {
        const overflow = scroller.scrollHeight - scroller.clientHeight
        if (overflow <= 0) break
        zoom = Math.max(MIN_ZOOM, zoom - overflow / height)
        mascot.style.zoom = String(zoom)
      }
    }
    fit()
    if (typeof ResizeObserver === 'undefined') return
    const observer = new ResizeObserver(fit)
    observer.observe(scroller)
    observer.observe(content)
    return () => observer.disconnect()
  }, [enabled])

  return { scrollerRef, mascotRef, contentRef }
}
